/* WhatsApp checkout: Checkout and Buy Now send a prefilled order message to WhatsApp.
   Add to Cart is untouched. Config comes from window.waCheckout (see snippets/wa-checkout.liquid). */
(function () {
  var cfg = window.waCheckout;
  if (!cfg || !cfg.enabled || !cfg.number) return;

  function fmt(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function absUrl(path) {
    return path && path.indexOf('http') === 0 ? path : location.origin + path;
  }

  function propsText(props) {
    if (!props) return '';
    var out = [];
    Object.keys(props).forEach(function (k) {
      if (k.charAt(0) === '_' || props[k] === '' || props[k] == null) return;
      out.push(k + ': ' + props[k]);
    });
    return out.length ? '   ' + out.join(', ') + '\n' : '';
  }

  function openWhatsApp(text) {
    var num = String(cfg.number).replace(/\D/g, '');
    window.location.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(text);
  }

  function busy(btn, on) {
    if (!btn) return;
    btn.classList.toggle('wa-busy', on);
    if (btn.tagName === 'BUTTON') btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  /* ---- Whole cart (cart page + cart drawer) ---- */
  function sendCart(btn) {
    busy(btn, true);
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.item_count) { busy(btn, false); return; }
        var msg = (cfg.intro || 'Hi, I would like to place this order:') + '\n\n';
        cart.items.forEach(function (it, i) {
          msg += (i + 1) + '. ' + it.product_title;
          if (it.variant_title) msg += ' (' + it.variant_title + ')';
          msg += ' x ' + it.quantity + ' = ' + fmt(it.final_line_price, cart.currency) + '\n';
          if (it.vendor) msg += '   Vendor: ' + it.vendor + '\n';
          msg += propsText(it.properties);
          msg += '   ' + absUrl(it.url) + '\n';
        });
        msg += '\nTotal: ' + fmt(cart.total_price, cart.currency);
        if (cart.note) msg += '\nNote: ' + cart.note;
        openWhatsApp(msg);
        setTimeout(function () { busy(btn, false); }, 1500);
      })
      .catch(function () { busy(btn, false); });
  }

  /* ---- Single product (Buy Now) ---- */
  function sendProduct(btn) {
    var form = btn.closest('form');
    var handle = btn.getAttribute('data-handle');
    if (!form || !handle) return;

    var terms = form.querySelector('.tearmCheck');
    if (terms && !terms.checked) { terms.focus(); return; }

    var fd = new FormData(form);
    var id = String(fd.get('id') || '');
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    var props = {};
    fd.forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (m && typeof v === 'string') props[m[1]] = v;
    });

    busy(btn, true);
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = p.variants.filter(function (x) { return String(x.id) === id; })[0] || p.variants[0];
        if (v && v.available === false) { busy(btn, false); return; }
        var title = p.title;
        if (v && v.public_title) title += ' (' + v.public_title + ')';
        var msg = (cfg.intro || 'Hi, I would like to place this order:') + '\n\n';
        msg += '1. ' + title + ' x ' + qty + ' = ' + fmt(v.price * qty) + '\n';
        if (p.vendor) msg += '   Vendor: ' + p.vendor + '\n';
        msg += propsText(props);
        msg += '   ' + location.origin + '/products/' + handle + (v ? '?variant=' + v.id : '') + '\n';
        msg += '\nTotal: ' + fmt(v.price * qty);
        openWhatsApp(msg);
        setTimeout(function () { busy(btn, false); }, 1500);
      })
      .catch(function () { busy(btn, false); });
  }

  /* Capture phase so we run before the theme's own handlers / form submit */
  document.addEventListener('click', function (e) {
    var buy = e.target.closest('[data-wa-buy-now]');
    if (buy) {
      e.preventDefault();
      e.stopPropagation();
      if (!buy.disabled) sendProduct(buy);
      return;
    }
    var co = e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (co) {
      e.preventDefault();
      e.stopPropagation();
      if (!co.disabled) sendCart(co);
    }
  }, true);

  /* Enter key / programmatic submit of the cart forms */
  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (s && s.name === 'checkout') {
      e.preventDefault();
      e.stopPropagation();
      sendCart(s);
    }
  }, true);
})();